import { ENTRY_POINT_NAMES, isPrivateBookingPage } from '#shared/entry-points';

export default defineNuxtRouteMiddleware((to) => {
  // Client navigation always comes from within the app, where the state making the page valid already exists.
  if (import.meta.client) {
    return;
  }

  // An unmatched URL is a plain 404: let Nuxt render its error page. Absorbing it into the home
  // redirect below would serve a 200 for every broken URL — a soft-404 hiding errors from crawlers.
  if (to.matched.length === 0) {
    return;
  }

  const routeBaseName = useRouteBaseName();
  const name = routeBaseName(to);
  // Design-system pages are served in development only, so the guard has nothing to redirect.
  if (import.meta.dev && typeof name === 'string' && (name === 'design-system' || name.startsWith('design-system-'))) {
    return;
  }
  if (typeof name === 'string' && (ENTRY_POINT_NAMES.has(name) || isPrivateBookingPage(name))) {
    return;
  }

  // Cold direct access to a funnel page: the store is empty and the page would render broken.
  const localePath = useLocalePath();
  return navigateTo(localePath('index'), { redirectCode: 302 });
});
